import type { ReactNode } from 'react';

import { PageHeader, type PageHeaderProps } from './page-header';
import { PageShell, type PageShellProps } from './page-shell';
import { ScrollArea } from './scroll-area';

export interface ScreenFrameProps extends Omit<PageShellProps, 'title' | 'as'> {
  title: PageHeaderProps['title'];
  description?: PageHeaderProps['description'];
  actions?: PageHeaderProps['actions'];
  children?: ReactNode;
}

/**
 * 한 컬럼 화면 한 벌 — 셸의 본문 영역 안에서 스크롤하는 `ScrollArea` + `PageShell` + `PageHeader`.
 * 화면이 같은 세 겹을 손으로 쌓지 않게 한다. 폭·간격 변형은 `PageShell` 그대로다.
 * 분할 화면은 이것 대신 `Workbench`·`MasterDetail`이다.
 */
export function ScreenFrame({
  title,
  description,
  actions,
  width,
  gap,
  fill,
  className,
  children,
  ...props
}: ScreenFrameProps) {
  return (
    <ScrollArea className="h-full">
      <PageShell width={width} gap={gap} fill={fill} className={className} {...props}>
        <PageHeader title={title} description={description} actions={actions} />
        {children}
      </PageShell>
    </ScrollArea>
  );
}
